import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-youtube', 'IconBrandYoutube', [
  [
    'path',
    {
      d: 'M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M10 9l5 3l-5 3z', key: 'svg-1' }],
]);
